module.exports = __webpack_public_path__ + "static/img/advantage2.dd0c72b1.png";